import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/company',
    element: <CompanyPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
